export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Funktionen']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Bestellen',
        to: '/order/Order',
        icon: 'cil-basket',

      },
      {
        _name: 'CSidebarNavItem',
        name: 'Bestellungen freigeben',
        to: '/order/Approve',
        icon: 'cil-cart',
        
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Bestellhistorie',
        to: '/order/History',
        icon: 'cil-check',

      },
      {
        _name: 'CSidebarNavItem',
        name: 'Lager',
        to: '/order/Ledger',
        icon: 'cil-check',

      }
      
    ]
  }
]